<template>
  <div class="image-container" :class="options.imageRatioClass">
    <div class="animated-background">
      <div class="background-masker content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({ height: '500', imageRatioClass: 'image-4-3' }),
    },
    customClass: {
      type: String,
      default: '', // two-columns
    },
  },
  methods: {
    unitPixel(value) {
      return `${value}px`;
    },
    calContentBottomHeight(height) {
      if (height) {
        return this.unitPixel(height / 2);
      }
      return '100px';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';


.image-container {
  background: none;
}

@keyframes placeHolderShimmer {
  0%{ background-position: -50% 0; }
  100%{ background-position: 50% 0; }
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeHolderShimmer;
  background: #f6f7f8;
  background: linear-gradient(to right, #efefef, #eaeaea, #efefef);
  background-size: 50% 104px;
  position: relative;
  padding-top: 56.25%;
}

.background-masker {
  position: absolute;
}

.image-container.image-4-3 {
  .animated-background {
    padding-top: 75%;
  }
}

.image-container.image-1-1 {
  .animated-background {
    padding-top: 100%;
  }
}

/* Every thing below this is just positioning */

.background-masker.content {
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}


@media (max-width: 575.98px) {
 .section-prefetch {
    .animated-background {
      .background-masker.content-bottom {
        height: 0px !important;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
      }
    }
  }
}


</style>
